import {CHANGE_POPUP} from '../reducers/popupReducer'

import { CHANGE_POPUP_CACHE } from '../constants'

const openPopup = (currentPopup, data) => ({
  type: CHANGE_POPUP,
  state: {
    currentPopup,
    data,
  },
})

export const closePopup = () => (dispatch) => {
  dispatch({
    type: CHANGE_POPUP,
    state: {
      currentPopup: null,
      data: null,
    },
  })
}

export const updateCachePopupData = (key, value) => (dispatch) => {
  dispatch({
    type: CHANGE_POPUP_CACHE,
    key,
    value,
  })
}

export const getCachePopupData = (key) => (dispatch, getState) => {
  const {popup: {cache}} = getState();
  return cache[key]
}

export default (currentPopup, data) => dispatch => dispatch(openPopup(currentPopup, data))
